import React, { useState } from 'react';
import { FaRegUserCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://dummyjson.com/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: 'kminchelle', password: '0lelplR' }),
      });
      const data = await res.json();
      navigate('/', { state: { authToken: data.token } });
    } catch (error) {
      toast.error('Login failed, please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <h2 className="mb-6 text-xl font-bold text-gray-900">Login</h2>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading}
          className="mx-auto flex flex-col items-center gap-3 rounded-xl border border-gray-200 px-8 py-6 transition hover:border-brand-400 hover:bg-brand-50 disabled:opacity-60"
        >
          <FaRegUserCircle size={72} className="text-gray-300" />
          <span className="text-sm font-semibold text-gray-700">{loading ? 'Signing in…' : 'Continue as Demo User'}</span>
        </button>
        <p className="mt-4 text-xs text-gray-400">Uses a dummyjson.com test account — no real credentials needed.</p>
      </div>
    </div>
  );
};

export default Login;
